import type { H3Event } from 'h3';

// Written here and by the server plugins whose fallbacks degrade a render; read by
// server/plugins/09.degraded-render-cache.ts to keep that render uncached. Declared from this
// module (not a global .d.ts): augmentation needs a module context, and editors strip a lone
// `export {}` from declaration files.
declare module 'h3' {
  interface H3EventContext {
    renderDegraded?: boolean;
  }
}

// Flags the current SSR document render as degraded — a fallback served instead of live data.
// server/plugins/09.degraded-render-cache.ts then keeps that render out of every cache layer
// (route cache, CDN, browser): a degraded document must stay a cache miss.
export const markRenderDegraded = (event?: H3Event): void => {
  if (event) {
    event.context.renderDegraded = true;
  }
};
